import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";

import FormsListElement from "./formsListElement";

const FormsCategoryListElements = ({ categories = [] }) => {
  const data = useStaticQuery(graphql`
    {
      allKontentItemForm {
        nodes {
          ...FormsListElement
        }
      }
    }
  `);

  const filteredData = [];
  data.allKontentItemForm.nodes.forEach((node) => {
    node.elements.resource_type.value.forEach((category) => {
      if (categories.includes(category.codename)) {
        filteredData.push(node);
      }
    });
  });

  if (data.allKontentItemForm) {
    return FormsListElement({ data: filteredData });
  }

  return null;
};

FormsCategoryListElements.propTypes = {
  categories: PropTypes.oneOfType([PropTypes.array]),
};

export default FormsCategoryListElements;
